import React, { useEffect, useRef, useState } from 'react';
import { Box, TextField, Typography, CircularProgress } from '@mui/material';
import { getStudentNotes, saveStudentNotes } from '../../services/studentSessionService';

interface PlaygroundNotesProps {
  sessionId: number;
}

const DEBOUNCE_MS = 5_000;

const PlaygroundNotes: React.FC<PlaygroundNotesProps> = ({ sessionId }) => {
  const [content, setContent] = useState('');
  const [saving, setSaving] = useState(false);
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    getStudentNotes(sessionId).then(setContent).catch(() => {});
  }, [sessionId]);

  const handleChange = (value: string) => {
    setContent(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setSaving(true);
      saveStudentNotes(sessionId, value).finally(() => setSaving(false));
    }, DEBOUNCE_MS);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', p: 1 }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
        <Typography variant="caption" fontWeight={600} color="text.secondary">MY NOTES</Typography>
        {saving && <CircularProgress size={12} />}
      </Box>
      <TextField
        multiline
        fullWidth
        placeholder="Take notes here… auto-saved every 5 seconds"
        value={content}
        onChange={(e) => handleChange(e.target.value)}
        variant="outlined"
        sx={{ flex: 1, '& .MuiInputBase-root': { height: '100%', alignItems: 'flex-start' } }}
        inputProps={{ style: { height: '100%' } }}
      />
    </Box>
  );
};

export default PlaygroundNotes;
